module.exports = __webpack_public_path__ + "react/sources/images/empty.svg";